
export const LoadingSkeleton = () => (
    <div className="overflow-x-auto rounded-xl shadow-lg">
        <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-100">
            <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">ID</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Size</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Uploaded by</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Date & Time Uploaded</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Actions</th>
            </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200 animate-pulse">
            {[...Array(3)].map((_, i) => (
                <tr key={i}>
                    {Array(7).fill(0).map((_, j) => (
                        <td key={j} className="px-6 py-4">
                            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                        </td>
                    ))}
                </tr>
            ))}
            </tbody>
        </table>
    </div>
);